var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shippingList" }, [
    _c("div", { staticClass: "main print-font" }, [
      _c("div", { staticClass: "title print-font" }, [_vm._v("三方发货清单")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "print-font" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.shippingForm,
                "label-position": "left"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "名称:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.shop_name))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "日期:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.date))
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-form-item", { attrs: { label: "收货方:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.user_name))
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "收货地址:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.address))
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "联系方式:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.mobile))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.shippingTableData,
                border: "",
                "span-method": _vm.objectSpanMethod,
                "show-summary": "",
                "summary-method": _vm.getSummaries
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "推送时间" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.serial_number
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.serial_number
                                    .split("-")
                                    .slice(3)
                                    .join("-")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.express && _vm.isZhifaOrFactory
                          ? _c("span", [
                              _vm._v("(" + _vm._s(scope.row.express) + ")")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mo_statusName", label: "状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "打包称重(kg)" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "box_num", label: "打包箱数" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "box_code", label: "箱码", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.box_code
                          ? _c(
                              "span",
                              _vm._l(scope.row.box_code.split(","), function(
                                item
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: item,
                                    staticStyle: { display: "block" }
                                  },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "是否签收" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "warning-info" }, [
            _vm._v(
              "注意：签收前请查验货物，您的签名意味着货物签收确认。签收人签名："
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.myPrint }
          },
          [_vm._v("打印")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f4a4339", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4a4339","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/shippingList.vue
// module id = null
// module chunks = 